// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control-wrapper {
  display: flex;
  align-items: center;
  margin: 8px 0 14px;
}
.form-control-wrapper .thumbnail {
  margin-right: 20px;
}
.form-control-wrapper .btn.select-btn {
  border: none;
  margin: 0;
  background: transparent;
  padding: 0;
  border-radius: 0;
}

.main-form {
  display: flex;
  flex-direction: column;
  align-items: normal;
  padding-bottom: 32px;
  min-width: 288px;
}

.divider {
  position: relative;
  display: flex;
  align-items: center;
  padding-right: 6px;
}
.divider .btn--icon {
  width: 48px;
  height: 48px;
  position: relative;
  border-radius: 16px;
  border: 1px solid rgba(20, 37, 41, 0.3);
  background: rgba(20, 37, 41, 0.1);
  padding: 0;
}
.divider:before {
  content: "";
  position: relative;
  height: 1px;
  background: #A8AEB0;
  width: calc(100% - 72px - 6px);
  flex: 1 1;
  left: -16px;
}

.form-actions {
  display: flex;
  align-items: center;
}
.form-actions button:first-child:not(:only-child) {
  margin-right: 16px;
}

.submit-btn {
  width: 100%;
}
.submit-btn span {
  font-weight: 700;
  color: black;
}

.pos-relative {
  position: relative;
}
.pos-relative .error-msg {
  width: 100%;
  color: #FA3737;
  display: block;
  margin-top: 8px;
}

.hint-msg {
  margin-top: 8px;
}

.form-control--big .form-input {
  width: calc(100% - 100px);
}

.mb-30 {
  margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/MercuryoWidget/Styles/FormStyles.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;AAIE;EACE,kBAAA;AAFJ;AAKE;EACE,YAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAHJ;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,oBAAA;EACA,gBAAA;AAJF;;AAMA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,iCAAA;EACA,UAAA;AAFJ;AAIE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;AAFJ;;AAKA;EACE,aAAA;EACA,mBAAA;AAFF;AAGE;EACE,kBAAA;AADJ;;AAIA;EACE,WAAA;AADF;AAEE;EACE,gBAAA;EACA,YAAA;AAAJ;;AAGA;EACC,kBAAA;AAAD;AACE;EAIE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAFJ;;AAKA;EACE,eAAA;AAFF;;AAIA;EACE,yBAAA;AADF;;AAGA;EACE,mBAAA;AAAF","sourcesContent":["@import \"src/assets/styles/variables\";\n\n.form-control-wrapper{\n  display: flex;\n  align-items: center;\n  margin: 8px 0 14px;\n\n  //border: 1px solid var(--color-main-border);\n  //border-radius: 8px;\n  //padding: 13px 16px;\n  .thumbnail{\n    margin-right: 20px;\n  }\n\n  .btn.select-btn{\n    border: none;\n    margin: 0;\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n  }\n}\n.main-form{\n  display: flex;\n  flex-direction: column;\n  align-items: normal;\n  //height: 100%;\n  padding-bottom: 32px;\n  min-width: 288px;\n}\n.divider{\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding-right: 6px;\n  .btn--icon{\n    width: 48px;\n    height: 48px;\n    position: relative;\n    border-radius: 16px;\n    border: 1px solid rgba(20, 37, 41, 0.30);\n    background: rgba(20, 37, 41, 0.10);\n    padding: 0;\n  }\n  &:before{\n    content: \"\";\n    position: relative;\n    height: 1px;\n    background: #A8AEB0;\n    width: calc(100% - 72px - 6px);\n    flex: 1;\n    left: -16px;\n  }\n}\n.form-actions{\n  display: flex;\n  align-items: center;\n  button:first-child:not(:only-child){\n    margin-right: 16px;\n  }\n}\n.submit-btn{\n  width: 100%;\n  span{\n    font-weight: 700;\n    color: black;\n  }\n}\n.pos-relative{\n position: relative;\n  .error-msg{\n    //position: absolute;\n    //bottom: -20px;\n    //left: 0;\n    width: 100%;\n    color: #FA3737;\n    display: block;\n    margin-top: 8px;\n  }\n}\n.hint-msg{\n  margin-top: 8px;\n}\n.form-control--big .form-input{\n  width: calc(100% - 100px);\n}\n.mb-30{\n  margin-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
